export default function LoadingIndicator() {
  return (
    <div className="flex items-center justify-center py-4">
      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#005E6E]"></div>
      <span className="ml-2 text-sm text-[#005E6E]">Loading...</span>
    </div>
  );
} 